<template>
  <div class="login-page-center">
    <div class="login-title">黑密秀发AI诊断系统</div>
    <div class="login-container">
      <van-form @submit="onSubmit">
        <van-row gutter="16">
          <van-col :span="24">
            <van-field
              v-model="username"
              label="手机号"
              placeholder="请输入手机号"
              required
            />
          </van-col>

          <van-col :span="24">
            <van-field
              v-model="password"
              label="授权密码"
              type="password"
              placeholder="请输入授权密码"
              required
            />
          </van-col>

          <!-- Submit Button -->
          <van-col :span="24">
            <div style="margin: 16px;">
              <van-button round block type="info" native-type="submit">
                登录
              </van-button>
            </div>
          </van-col>
        </van-row>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    async onSubmit() {
      if (this.username === "") {
        this.$toast.fail('请输入手机号');
        return;
      }

      if (this.password === "") {
        this.$toast.fail('请输入授权密码');
        return;
      }

      try {
        const res = await this.$axios.get('http://xiyuyangfa.online:8080/api/phone/verify', {
          params: {
            phone: this.username,
            password: this.password
          },
        });

        if (res.data && res.data.code === 200) { // 检查状态码是否成功
          if (res.data.data === true) { // 检查 data 是否为 true.
            localStorage.setItem('phone', this.username);
            this.$router.push('/home'); // 跳转首页
          } else {
            this.$toast.fail('账号未授权'); // data 为 false 时提示失败
          }
        } else {
          this.$toast.fail(res.data.message || '登录失败'); // 其他错误情况
        }
      } catch (e) {
        this.$toast.fail('网络错误'); // 捕获网络错误
      }
    }
  }
}
</script>

<style scoped>
.login-page-center {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f7fafc 0%, #e3e9f0 100%);
}

.login-title {
  font-size: 2.2rem;
  color: #fb7e22;
  font-weight: bold;
  margin-bottom: 32px;
  letter-spacing: 2px;
  text-align: center;
  text-shadow: 0 2px 8px rgba(251,126,34,0.08);
}

.login-container {
  width: 100%;
  max-width: 400px; /* Adjust based on your design needs */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.10);
  padding: 48px 40px 32px 40px;
  margin: 0 auto;
}

.van-form {
  width: 100%;
}

.van-field {
  margin-bottom: 24px;
  border-radius: 8px;
  overflow: hidden;
  background: #f7f8fa;
}

.van-button {
  font-size: 18px;
  padding: 12px 0;
  border-radius: 24px;
  background: linear-gradient(90deg, #36d1c4 0%, #5b86e5 100%);
  border: none;
  color: #fff;
  box-shadow: 0 2px 8px rgba(91,134,229,0.15);
  transition: background 0.3s;
}

.van-button:active {
  background: linear-gradient(90deg, #5b86e5 0%, #36d1c4 100%);
}


</style>